import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Alert } from "@/ui";
import { errorMessage } from "./api";
import { useMe } from "./auth";

/** 路由守卫：确认有会话才渲染子路由，没有就带着当前地址去登录页（docs/04 第 9 节）。 */
export function RequireAuth() {
  const me = useMe();
  const { pathname, search } = useLocation();
  if (me.isPending) return null;
  if (me.isError) return <Alert tone="danger" title="无法确认登录状态">{errorMessage(me.error)}</Alert>;
  if (!me.data) return <Navigate to={`/login?next=${encodeURIComponent(pathname + search)}`} replace />;
  return <Outlet />;
}
